/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <p>Classification of questions based on customer satisfaction\/effort<\/p>
 **/
export var QuestionClassification;
(function (QuestionClassification) {
    QuestionClassification["CUSTOMER_SATISFACTION_QUESTION"] = "CustomerSatisfactionQuestion";
    QuestionClassification["CUSTOMER_EFFORT_QUESTION"] = "CustomerEffortQuestion";
})(QuestionClassification || (QuestionClassification = {}));
